import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslator } from '@jutro/locale';
import {
    Button,
    ModalBody,
    ModalNext,
    Icon
} from '@jutro/components';
import { GridItem } from '@jutro/layout';
import messages from './AdacCommonModal.messages';

function AdacErrorModal({
    isOpen,
    onResolve,
    onReject,
    onAfterClose,
    message,
    token,
    redirectEnabled
}) {
    const history = useHistory();
    const translator = useTranslator();
    const TEL_NUMBER = translator(messages.phoneNumber);

    const handleClose = useCallback(() => {
        return onReject();
    }, [onReject]);

    const handleConfirm = useCallback(() => {
        return onResolve();
    }, [onResolve]);

    const makeCall = useCallback((event) => {
        handleConfirm();
        event.preventDefault();
        window.location.href = `tel:${TEL_NUMBER}`;
        if (redirectEnabled === true) {
            history.push({ pathname: `/login/${token}` });
        }
    }, [TEL_NUMBER, handleConfirm, history, redirectEnabled, token]);

    const backToLoginPage = () => {
        handleConfirm();
        if (redirectEnabled === true) {
            history.push({ pathname: `/login/${token}` });
        }
    };

    return (
        <ModalNext
            isOpen={isOpen}
            onRequestClose={handleClose}
            onAfterClose={onAfterClose}
        >
            <Icon
                icon="mi-error-outline"
                size="small"
                className="alertIcon"
            />
            <ModalBody
                contentLayout={{
                    component: 'Grid',
                    componentProps: {
                        columns: ['1fr'],
                    },
                }}
                autoFocus
            >
                <GridItem>
                    <h3 Style="text-align: center">{message}</h3>
                </GridItem>
            </ModalBody>
            <div Style="text-align: center; margin-top: .5rem">
                <Button onClick={makeCall} icon="phone">
                    {TEL_NUMBER}
                </Button>
            </div>
            <div Style="text-align: center; margin-top: .5rem; margin-bottom: .5rem">
                <Button onClick={backToLoginPage} type="outlined">
                    <h2>{translator(messages.back)}</h2>
                </Button>
            </div>
        </ModalNext>
    );
}

export default AdacErrorModal;
